// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"a39fa16d","74":"ea365901","219":"04625a2c","278":"0bf76732","414":"3671cd47","429":"dfbc8a32","507":"d9d908d1","743":"777909bd","838":"797d1234"}[chunkId] + ".chunk.js";
};